module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/typography.component.scss
// module id = ./src/app/features/typography/typography.component.scss
// module chunks = main